import React from 'react';
import CefCard from "../../../Layout/CefCard";
import { ProgressBarProvider } from "../../../Providers";
import Layout from "../../../Layout/Wrappers/Layout";
import { useIsMobile } from "../../useIsMobile";
import Content from "../Content";
import PrerequisiteRedirect from "./PrerequisiteRedirect";
import Progress from "../../../../Wizards/Progress";
export var ResultsFormat = function ResultsFormat(_ref) {
  var onExit = _ref.onExit,
    onSave = _ref.onSave;
  var isMobile = useIsMobile();
  var resultsContent = /*#__PURE__*/React.createElement(Layout, {
    noBackButton: true,
    onExit: onExit,
    onSave: onSave
  }, /*#__PURE__*/React.createElement(PrerequisiteRedirect, null, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 100
  }, /*#__PURE__*/React.createElement(Progress, null)), /*#__PURE__*/React.createElement(Content, {
    onExit: onExit
  })));
  return isMobile ? resultsContent : /*#__PURE__*/React.createElement(CefCard, null, resultsContent);
};